import { yupResolver } from '@hookform/resolvers/yup'
import moment from 'moment/moment'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Form,
  Label,
  Row
} from 'reactstrap'
import ResponsiveDatePickers from '../../../components/date-picker/index'
import {
  InputEmail,
  InputNumber,
  InputPhone,
  InputText
} from '../../../components/inputs'
// import { getData, setInitialData } from '../store'
import { getData, setInitialData, setOpenModal } from '../store'
import SchemaValidations from './validations'
import { sendFiltersAdapter } from '../adapters'
import Create from '../form/Create'
import Edit from '../form/Edit'
import DeleteUser from './delete-item/delete-item'
import { UploadCloud } from 'react-feather'
import { producTypesdb } from '../../invoice-issuance/db/producTypes'

const initialFilterProps = {
  clientCode: '',
  codeType: '',
  dteType: '',
  company: '',
  receiverEmail: '',
  receiverPhoneNumber: '',
  receiverName: '',
  // startDate: moment().subtract(1, 'day'),
  // endDate: null
}

const FilterForm = ({ onFilter, setFilteredData }) => {
  const [filterProps, setFilterProps] = useState(initialFilterProps)
  const [areaFilterValue, setAreaFilterValue] = useState(null)
  const dispatch = useDispatch()
  const { isPending } = useSelector((state) => state.transactions)
  const { data } = useSelector(state => state.productServiceMaster)


  /*useEffect(() => {
    dispatch(getData({}))

  }, [])*/

  // useForm
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      ...initialFilterProps
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(SchemaValidations)
  })

  const handleClearFilters = () => {
    setFilterProps(initialFilterProps)
    setAreaFilterValue(null)
    //dispatch(getData({}))
    setFilteredData(data)
    reset()
  }

  const onSubmit = async (submitData) => {
    // const previousDay = moment(filterProps.startDate).subtract(1, 'day')
    const filter = {
      ...submitData
    }

    onFilter(filter)
    const newFilters = sendFiltersAdapter(filter)
    if (Object.keys(newFilters).length === 0) {
      return
    } else {
      const fiteredData = await dispatch(getData(
        {
          filters: {...newFilters, prodType: submitData.prodType },
          data
        }))
      console.log("fiteredData: ", fiteredData)
      console.log("Filtro compuesto: ", {...newFilters, prodType: submitData?.prodType ? submitData?.prodType : ""  })
      setFilteredData(fiteredData.payload)
    }
  }

  const consultOnce = useRef(1)

  const handleNewCustomer = () => {
    dispatch(setOpenModal({ open: true, type: 'create' }))
  }

  return (
    <Fragment>
      <Create />
      <Edit />
      <DeleteUser />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
            <CardTitle tag="h4">Maestro de productos / servicios</CardTitle>
            <Button color="primary" onClick={handleNewCustomer}><UploadCloud size={20}/> Crear </Button>
          </CardHeader>
          <Row className="mx-0" style={{ paddingTop: '2%', paddingLeft: '5%' }}>
          <Col>
              <Label
              className='me-1'
              >Tipo de producto</Label>
              <Controller
                name='prodType'
                control={control}
                render={({field}) => (
                  <>
                    <Select
                    options={producTypesdb}
                    //value={filterProps.codeType ? { value: filterProps.codeType, label: filterProps.codeType === 'dui' ? 'DUI' : 'NIT' } : null}
                    onChange={(e) => {
                        //setFilterProps({ ...filterProps, dteType: e.value})
                        field.onChange({label: e.label, value: e.value, id: e.id})
                        //setValue('clientCode', '')
                    }}
                    />
                    {errors.docType && <FormFeedback className="d-block">{errors.docType.message}</FormFeedback>}
                  </>
                  
                )}
                
              />
            </Col>
            <Col md="4" sm="12">
                <InputText
                  label={'Nombre de producto/servicio'}
                  errors={errors}
                  options={{
                    control,
                    id: 'productName',
                    name: 'productName'
                  }}
                />
              </Col>

            <Col md="4" sm="12">
              <InputNumber
                  label={"Código de producto/servicio"}
                  errors={errors}
                  control={control}
                  
                  options={{
                    id: 'productCode',
                    name: 'productCode',
                    startWithCero: true,
                  }}
                />
            </Col>
          </Row>

          <Row>
            <Col className="d-flex align-items-center justify-content-sm-center mx-2 my-3">
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="submit"
                disabled={isPending}
                onClick={() => onFilter(filterProps)}
              >
                Búsqueda
              </Button>
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="reset"
                onClick={handleClearFilters}
              >
                Limpiar Filtros
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>
    </Fragment>
  )
}

export default FilterForm
